// Auto-generated by scripts/generate_daily_seo_content.js
// Do not edit this file manually.

const dailySeoContent = {
  "updatedAt": "2026-10-19",
  "topic": "德扑平台安装教程 / hhpoker安装教程 / 德扑下载入口",
  "metaKeywords": "德扑平台安装教程, hhpoker安装教程, 德扑下载入口, 德扑下载最新版, hhpoker官网入口, hhpoker下载, hhpoker最新下载, 德州扑克下载, 德扑平台下载, 德州扑克平台下载",
  "focusKeywords": [
    {
      "keyword": "德扑平台安装教程",
      "path": "/install-guide",
      "anchorText": "德扑平台安装教程"
    },
    {
      "keyword": "hhpoker安装教程",
      "path": "/install-guide",
      "anchorText": "hhpoker安装教程详解"
    },
    {
      "keyword": "德扑下载入口",
      "path": "/download",
      "anchorText": "德扑下载入口指南"
    },
    {
      "keyword": "德扑下载最新版",
      "path": "/download",
      "anchorText": "德扑下载最新版"
    },
    {
      "keyword": "hhpoker官网入口",
      "path": "/",
      "anchorText": "hhpoker官网入口入口"
    },
    {
      "keyword": "hhpoker下载",
      "path": "/download",
      "anchorText": "hhpoker下载指南"
    },
    {
      "keyword": "hhpoker最新下载",
      "path": "/download",
      "anchorText": "hhpoker最新下载"
    },
    {
      "keyword": "德州扑克下载",
      "path": "/download",
      "anchorText": "德州扑克下载入口"
    },
    {
      "keyword": "德扑平台下载",
      "path": "/download",
      "anchorText": "德扑平台下载指南"
    },
    {
      "keyword": "德州扑克平台下载",
      "path": "/download",
      "anchorText": "德州扑克平台下载"
    }
  ],
  "faqEntries": [
    {
      "name": "德扑平台安装教程怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "从官方渠道下载最新安装包，安卓允许未知来源后直接覆盖安装；iOS需在设置中信任企业证书，全程保持Wi-Fi连接。"
      },
      "linkPath": "/install-guide"
    },
    {
      "name": "hhpoker安装教程怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "从官方渠道下载最新安装包，安卓允许未知来源后直接覆盖安装；iOS需在设置中信任企业证书，全程保持Wi-Fi连接。"
      },
      "linkPath": "/install-guide"
    },
    {
      "name": "德扑下载入口怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "从官方渠道下载最新安装包，安卓允许未知来源后直接覆盖安装；iOS需在设置中信任企业证书，全程保持Wi-Fi连接。"
      },
      "linkPath": "/download"
    },
    {
      "name": "德扑下载最新版怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "从官方渠道下载最新安装包，安卓允许未知来源后直接覆盖安装；iOS需在设置中信任企业证书，全程保持Wi-Fi连接。"
      },
      "linkPath": "/download"
    }
  ]
};

export default dailySeoContent;
